import {
  AfterContentChecked,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import find from 'lodash/find';
import { tap } from 'rxjs/operators';
import { FlowManagerService } from '../../../services/flow-manager.service';

export interface FlowIssueItem {
  id: number;
  location: string;
  environment: string;
  channel: string;
  description: string;
  action: string;
  src: string;
  type: string;
  step?: string;
}

@Component({
  selector: 'flow-issues-table',
  templateUrl: './flow-issues-table.component.html',
  styleUrls: ['./flow-issues-table.component.scss'],
})
export class FlowIssuesTableComponent implements OnInit, AfterContentChecked, OnDestroy {
  flowIssuesList: MatTableDataSource<FlowIssueItem>;
  displayedColumns: string[] = [
    'id',
    'location',
    'environment',
    'channel',
    'description',
    'action',
  ];
  availableChannels: any = [];
  channels: any = null;
  issuesToShow: FlowIssueItem[] = [];
  issuesPages = {
    pagesLength: 0,
    pages: {},
  };
  currPage: Number = 0;
  endList: Boolean = false;
  loadMore: Boolean = false;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() goTo = new EventEmitter();
  @Input() issues: FlowIssueItem[];

  @Input() flowName: string;

  constructor(private flowManagerService: FlowManagerService) {}

  ngOnInit() {
    window.addEventListener('scroll', this.scrollEvent, true);
    this.setIssuesPages();
    this.getData();

    this.channels = this.flowManagerService
      .getAllChannelConfig()
      .pipe(
        tap((config) => {
          this.availableChannels = config;
        })
      )
      .subscribe();
  }

  ngAfterContentChecked() {}

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollEvent, true);
    this.channels.unsubscribe();
  }

  scrollEvent = (event: any): void => {
    this.onTableScroll(event);
  };

  setIssuesPages() {
    let pageNumber = 1;
    const issues = [...this.issues];
    while (issues.length > 20) {
      this.issuesPages.pages[pageNumber] = issues.splice(0, 20);
      pageNumber++;
    }
    this.issuesPages.pages[pageNumber] = issues;
    this.issuesPages.pagesLength = pageNumber;
    this.issuesToShow = this.issuesPages.pages[1];
    this.currPage = 1;
  }

  onMatSortChange() {
    this.flowIssuesList.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'location':
          return item.location ? item.location.toLowerCase() : '';
        default:
          return item[property];
      }
    };

    this.flowIssuesList.sort = this.sort;
  }

  setLocationPath(location, type) {
    const locationArr = location.split('/');
    if (type === 'flow' && locationArr.length > 1) {
      locationArr.pop();
      return locationArr.join('/') + ' /';
    }
    return null;
  }

  setLocationFlow(location, type) {
    if (type === 'flow') {
      const locationArr = location.split('/');
      return locationArr[locationArr.length - 1];
    }
    return location;
  }

  goToHandler(e, issue) {
    e.preventDefault();
    this.goTo.emit(issue);
  }

  setChannel(channelId) {
    const channel = find(this.availableChannels, (o) => {
      return o['channel-id'] === +channelId;
    });
    if (channel) {
      return channel['channel-name'];
    }
    return '-';
  }

  getData() {
    this.flowIssuesList = new MatTableDataSource(this.issuesToShow);
    this.flowIssuesList.sort = this.sort;
  }

  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight;
    const tableScrollHeight = e.target.scrollHeight;
    const scrollLocation = e.target.scrollTop;
    if (tableScrollHeight - scrollLocation - tableViewHeight < 200) {
      if (this.currPage < this.issuesPages.pagesLength && !this.endList) {
        this.loadMore = true;
        window.setTimeout(() => {
          this.loadMore = false;
          // @ts-ignore
          if (this.issuesPages.pages[this.currPage + 1]) {
            // @ts-ignore
            this.currPage++;
            // @ts-ignore
            this.issuesToShow = [...this.issuesToShow, ...this.issuesPages.pages[this.currPage]];
            this.getData();
          }
        }, 2000);
      }
      if (this.issuesPages.pagesLength === this.currPage) {
        this.endList = true;
      }
    }
  }
}
